module.exports = __webpack_public_path__ + "static/media/upp_flo_acc_rou.106dbb0c.png";